// Import model
import { FilterOtgCatalogStyleRequest } from '../models/FilterOtgCatalogStyleRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { OtgCatalogStyleCondition } from '../models/OtgCatalogStyleCondition';
import { OtgCatalogStyleFields } from '../models/OtgCatalogStyleFields';
import { OtgCatalogStyleIndexedFields } from '../models/OtgCatalogStyleIndexedFields';

// Import dependency serializers (for complex types)
import { OtgCatalogStyleConditionSerializer } from './OtgCatalogStyleConditionSerializer';
import { OtgCatalogStyleFieldsSerializer } from './OtgCatalogStyleFieldsSerializer';
import { OtgCatalogStyleIndexedFieldsSerializer } from './OtgCatalogStyleIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterOtgCatalogStyleRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterOtgCatalogStyleRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterOtgCatalogStyleRequest instance
   */
  static deserialize(json: string): FilterOtgCatalogStyleRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterOtgCatalogStyleRequest instance
   */
  static fromObject(obj: any): FilterOtgCatalogStyleRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterOtgCatalogStyleRequest');
    }


    const instance: FilterOtgCatalogStyleRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as OtgCatalogStyleIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as OtgCatalogStyleFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        OtgCatalogStyleConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterOtgCatalogStyleRequest instances
   */
  static deserializeArray(json: string): FilterOtgCatalogStyleRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterOtgCatalogStyleRequest instance to a JSON string
   */
  static serialize(instance: FilterOtgCatalogStyleRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterOtgCatalogStyleRequest instance to a plain object
   */
  static toObject(instance: FilterOtgCatalogStyleRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        OtgCatalogStyleConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterOtgCatalogStyleRequest instances to a JSON string
   */
  static serializeArray(instances: FilterOtgCatalogStyleRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
